import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import { ReactNode } from "react";
import * as Yup from "yup";

import {
  MessagingStrategyName,
  OwnedPhoneNumber,
} from "~frontend/__generated__/graphql";
import { InternalLink } from "~frontend/components/Link";
import { CampaignForView } from "~frontend/routes/subaccounts/campaignView/types";

const phoneUtil = PhoneNumberUtil.getInstance();

export const cleanPhoneNumber = (
  phoneNumber: string,
  countryIso = "US"
): string =>
  phoneUtil.format(
    phoneUtil.parse(phoneNumber, countryIso),
    PhoneNumberFormat.E164
  );

export const phoneNumberIsValid = (
  phoneNumber: string,
  countryIso = "US"
): boolean => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parse(phoneNumber, countryIso));
  } catch (_) {
    return false;
  }
};

export const prettyPhoneNumber = (
  phoneNumber: string,
  countryIso = "US"
): string =>
  phoneUtil.format(
    phoneUtil.parse(phoneNumber, countryIso),
    PhoneNumberFormat.NATIONAL
  );

export const displayPhoneNumber = (
  messagingStrategy: CampaignForView["messagingStrategy"],
  subaccountLink: (relativeLink: string) => string
): ReactNode => {
  if (messagingStrategy.strategy === MessagingStrategyName.Fake) {
    return "Fake";
  }

  if (
    messagingStrategy.strategy === MessagingStrategyName.Bandwidth_10DlcPool
  ) {
    return "10DLC Pool";
  }

  if ("ownedPhoneNumberPool" in messagingStrategy.config) {
    if (messagingStrategy.config.ownedPhoneNumberPool) {
      return (
        <InternalLink
          to={subaccountLink(
            `/phone-numbers/pools/${messagingStrategy.config.ownedPhoneNumberPool.id}`
          )}
        >
          {messagingStrategy.config.ownedPhoneNumberPool.name}
        </InternalLink>
      );
    }
    return "None";
  }

  const {
    config: { ownedPhoneNumber },
  } = messagingStrategy as unknown as {
    config: { ownedPhoneNumber: OwnedPhoneNumber };
  };

  return `${
    ownedPhoneNumber.displayName ? ownedPhoneNumber.displayName + " - " : ""
  } ${prettyPhoneNumber(ownedPhoneNumber.phoneNumber)}`;
};

export const yupPhoneNumber = Yup.string().test({
  name: "validPhoneNumber",
  message: "Phone number is invalid",
  test: pn => !pn || phoneNumberIsValid(pn),
});
